import React from 'react';
import usePropertyHandlers from '../../../hooks/usePropertyHandlers';
import AgComponentProperties from './AgComponentProperties';
import AiSpriteProperties from './AiSpriteProperties';

const PropertiesPanel = ({ replaceElementMedia }) => {
  const {
    selectedElement,
    handlePropertyChange,
    handleSliderStart,
    handleSliderEnd,
    handleToggleSection,
    getCurrentExpandedSections,
  } = usePropertyHandlers();

  if (!selectedElement) {
    return (
      <div className="h-full flex flex-col">
        <div className="p-4">
          <h2 className="bg-ag-black-800 border border-ag-black-400
                        rounded-lg font-regular text-base
                        text-white text-center px-2 py-1 mx-4">Dynamic Properties</h2>
        </div>
        <div className="flex-1 flex items-center justify-center text-white">
          <p className="text-sm">Select an element to edit properties</p>
        </div>
      </div>
    );
  }

  const isAiSprite = selectedElement?.type === 'ai';

  return (
    <div className="h-full flex flex-col select-none">
      {/* Header */}
      <div className="p-4">
        <h3 className="bg-ag-black-800 border border-ag-black-400
                      rounded-lg font-regular text-base text-white
                      text-center px-2 py-1">Dynamic Properties</h3>
      </div>

      {/* Properties Content */}
      <div className="flex-1 overflow-auto px-4">
        {isAiSprite ? (
          /* AI Sprite — Chat section with payload, media, and re-generation dialog.
             Uses its own useUpdateAiSpriteMedia hook internally to preserve type:'ai'. */
          <AiSpriteProperties
            element={selectedElement}
            onPropertyChange={handlePropertyChange}
            onSliderStart={handleSliderStart}
            onSliderEnd={handleSliderEnd}
          />
        ) : (
          /* Standard element properties */
          <div className="space-y-4">
            <AgComponentProperties
              element={selectedElement}
              onPropertyChange={handlePropertyChange}
              expandedSections={getCurrentExpandedSections()}
              onToggleSection={handleToggleSection}
              onSliderStart={handleSliderStart}
              onSliderEnd={handleSliderEnd}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertiesPanel;
